<template>
    <div>
        <ul v-if="getInformes && getInformes.length" class="informes">
            <li 
            v-for="(informe,i) in getInformes" 
            :key="i" 
            class="c-pointer" 
            @click="$emit('clickAction', informe)">
                <i class="el-icon-tickets"></i>
                <div>
                    <p>{{informe.descripcion}}</p>
                    <span>{{informe.detalle}}</span>
                </div>
                <i class="el-icon-arrow-right"></i>
            </li>
        </ul>
        <!--<el-alert v-else
            :closable="false"
            title="No hay informes"
            type="info">
        </el-alert>-->
        <div v-else class="empty">
            <img src="../../assets/EmptyInbox.png">
            <p>No hay informes</p>
        </div>
    </div>
</template>

<script>
	export default {
		name: 'Informes',
		props: {
            ficha: {
                type: Object,
                required: true
            }
        },
        computed: {
            getInformes() {
                if(this.ficha.informes && Object.keys(this.ficha.informes).length) {
                    return Object.keys(this.ficha.informes).map(i => {
                        return this.ficha.informes[i]
                    })
                }
            }
        },
        mounted() { this.$emit('created') }
	}
</script>

<style lang="scss">
// INFORMES
ul.informes {
    list-style: none;
    list-style: none;
    padding: 0px;
    margin: 0px;
    li {
        border: 1px solid #e4e7ed;
        margin-bottom: 5px;
        padding: 10px;
        display: flex;
        flex-direction: row;
        border-radius: 5px;
        align-items: center;

        i:first-child {
            font-size: 2rem;
            color:#4a596a;
        }

        > div {
            display: flex;
            flex-flow: column;
            flex-grow: 1;
            margin-left: 8px;
            p {
                margin: 0px 0px 5px 0px;
                font-size: 0.8rem;
                font-weight: 600;
                display: flex;
                align-items: baseline;
                i {
                    margin-right: 5px;
                }
            }
            span {
                font-size: 0.8rem;
                display: block;
            }
            &:hover {
                p {
                    color: #409eff;
                }
            }
        }
        
    }
}
</style>